import { create } from 'zustand';

import { City, Nullable, Province, } from '@/shared/interfaces';
import { Sector, Zone } from '@/shared/interfaces/erp/mantenimiento-operaciones';

export interface CoberturasStore {
  selectedProvince: Nullable<Province> | string;
  selectedCity: Nullable<City> | string;
  selectedZone: Nullable<Zone> | string | number;
  selectedSector: Nullable<Sector> | string | number;

  isShowCobertura: {
    province: boolean;
    city: boolean;
    zona: boolean;
    sector: boolean;
  };

  ///* actions
  setSelectedProvince: (value: Province | string) => void;
  setSelectedCity: (value: City | string) => void;
  setSelectedZone: (value: Zone | string | number) => void;
  setSelectedSector: (value: Sector | string | number) => void;
  setIsShowCobertura: (value: {
    province: boolean;
    city: boolean;
    zona: boolean;
    sector: boolean;
  }) => void;
}

export const useCoberturasStore = create<CoberturasStore>(set => ({
  selectedProvince: null,
  selectedCity: null,
  selectedZone: null,
  selectedSector: null,

  isShowCobertura: {
    province: true,
    city: false,
    zona: false,
    sector: false,
  },

  setSelectedProvince: (value: Province | string) => {
    set({ selectedProvince: value });
  },
  setSelectedCity: (value: City | string) => {
    set({ selectedCity: value });
  },
  setSelectedZone: (value: Zone | string | number) => {
    set({ selectedZone: value });
  },
  setSelectedSector: (value: Sector | string | number) => {
    set({ selectedSector: value });
  },
  setIsShowCobertura: (value: {
    province: boolean;
    city: boolean;
    zona: boolean;
    sector: boolean;
  }) => {
    set({ isShowCobertura: value });
  },
}));
